import BreadcrumbWidget from "csi/breadcrumb/Widget";
import DefView from "csi/def/View";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { CSSProperties, FunctionComponent } from "react";

interface BreadcrumbProps {
	/* set to true if only revision information and actions should be rendered */
	renderRevisionAndActions?: boolean;

	/* CSS styling to apply to root of view */
	style?: CSSProperties;
}

export const Breadcrumb: FunctionComponent<BreadcrumbProps> = observer((props) => {
	const { routerStore, sessionStore } = useStore();
	const { renderRevisionAndActions, style } = props;
	const { breadcrumbCtr, locationUrl } = routerStore;
	const { nonObservableCache } = sessionStore;
	const id = "__Breadcrumb__";
	const defView = Object.assign(new DefView(), {
		classController: BreadcrumbWidget,
		m_id: id,
		m_typeView: "Breadcrumb",
	});

	return (
		<DojoView
			forceRefresh={breadcrumbCtr}
			nodeUrl={locationUrl}
			style={style}
			viewId={id}
			viewParams={{
				cacheView: nonObservableCache,
				defView,
				renderRevisionAndActions,
			}}
		/>
	);
});

export default Breadcrumb;
